var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEars2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 85,
    viewBox: "0 0 41 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_5174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.222292 29.8869C4.38453 12.4791 21.0565 14.1961 34.5396 0.605639C35.6894 -0.551814 37.6594 0.0230802 37.9583 1.63278C42.8028 27.687 41.1931 66.9331 15.3382 83.444C8.70006 87.6829 0 82.7312 0 74.859V31.9412C0 31.2513 0.061322 30.5538 0.222292 29.8869Z",
    fill: "#E6AB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94816 33.1828C9.11391 21.6159 20.3818 22.3135 29.7871 13.4218C30.9446 12.3333 32.8609 12.9619 33.1292 14.5256C36.3716 33.2211 34.9305 60.5708 16.7792 72.2756C11.9654 75.38 5.62622 71.7774 5.62622 66.0514V35.6587C5.62622 34.8232 5.72587 33.9877 5.94816 33.1828Z",
    fill: "#E97A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_5174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.1199,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEars2);
export default __webpack_public_path__ + "static/media/ears-2.6bd1fc33a18244795784b53a2933ffd0.svg";
export { ForwardRef as ReactComponent };